<vb-ui-checkbox *ngIf="themed; else notThemed" [disabled]="isDisabled" [(ngModel)]="isChecked">
</vb-ui-checkbox>

<ng-template #notThemed>
	<input type="checkbox" [checked]="isChecked" [disabled]="isDisabled">
</ng-template>
